var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"p-scrolltop","appear":""},on:{"enter":_vm.onEnter}},[(_vm.visible)?_c('button',{ref:"button",class:_vm.containerClass,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('span',{class:_vm.iconClass})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }